import React from 'react'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next'
import { TabProps } from '../../../models/Sample'
import { ViewSampleDetailsRow } from './ViewSampleDetailsRow'
import { AppUtil } from '../../../utils/app.utils'
import _ from 'lodash'
import { MASTER_DATA_ID as MDI } from '../../../utils/constants'

export const StemCellTransplant = (props: TabProps) => {
  const { sampleDetails } = props
  const { t } = useTranslation()

  const translatn = 'viewSample.'
  const parentClass = ''
  const detailsArr = [
    {
      label: t(`${translatn}cellularTherapy`),
      value: AppUtil.convertBooleanToStr(sampleDetails?.cellularTherapy ?? null),
      show: true
    },
    {
      label: t(`${translatn}dateOfCellularTherapy`),
      value: sampleDetails?.dateOfCellularTherapy,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}ageAtCellularTherapy`),
      value: sampleDetails?.ageAtCellularTherapy,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}stemCellTransplantType`),
      value: sampleDetails?.stemCellTransplantType,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}sourceOfStemCells`),
      value: sampleDetails?.sourceOfStemCells,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}transplantationCenter`),
      value: sampleDetails?.transplantationCenter,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}conditioningRegimen`),
      value: sampleDetails?.conditioningRegimen,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}graftVersusHostDiseaseStatus`),
      value: sampleDetails?.graftVersusHostDiseaseStatus,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}acuteGVHDGrade`),
      value: sampleDetails?.acuteGVHDGrade,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}chronicGVHDStatus`),
      value: sampleDetails?.chronicGVHDStatus,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}engraftmentStatus`),
      value: sampleDetails?.engraftmentStatus,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}donorType`),
      value: sampleDetails?.donorType,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}hlaMatching`),
      value: sampleDetails?.hlaMatching,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
    {
      label: t(`${translatn}responseToSCT`),
      value: sampleDetails?.responseToSCT,
      show: sampleDetails?.cellularTherapy == MDI.CELLULAR_THERAPY_OPTION_YES
    },
  ]

  const data = detailsArr.filter((details) => details.show === true)

  const rowCount = _.chunk(data, 5)

  return (
    <Container fluid>
      <h5 className="fw-bold "> {t(`${translatn}stemCellTransplant`)}</h5>
      {rowCount.map((row, index) => (
        <ViewSampleDetailsRow
          key={index}
          index={index}
          rowArr={rowCount[index]}
          parentClass={parentClass}
        />
      ))}
    </Container>
  )
}
